import compose from 'utils/composeEnhancer'
import toggleSidebarStore from 'hooks/toggleSidebarStore'

export default compose(toggleSidebarStore)
